import { addImage } from './data.js'
import { getInstagramData } from './instagram.js'

export function postImage(el) {

  if (!el) {
    return
  }

  el.addEventListener('submit', (e) => {
    e.preventDefault()
    let fData = new FormData(el)
    addImage(fData)
    el.reset()
  })

  const instaGet = el.querySelector('.js-instagram-fetch')
  instaGet.addEventListener('click', (e) => {
    e.preventDefault()
    if (confirm('Are you sure?')) {
      getInstagramData(window.accessKey)
    }
  }, false)

}


// WEBPACK FOOTER //
// ./js/add-content.js